<template>
  <div>
    <h1 class="text-center font-extrabold text-xl">Nouveau profil</h1>
    <MerchantProfileForm v-model="merchantProfile" :organizationId="organizationId" @submit="submit" />
  </div>
</template>

<script>
import MerchantProfileForm from "@/components/merchant_profiles/MerchantProfileForm.vue";
import { mapActions } from "vuex";

export default {
  components: {
    MerchantProfileForm,
  },
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    storeId: {
      type: Number,
      required: false,
    },
  },
  emits: ["success"],
  data() {
    return {
      merchantProfile: {
        firstName: null,
        lastName: null,
        email: null,
        role: null,
        storeIds: this.storeId ? [this.storeId] : [],
      },
    };
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("merchantProfiles", ["create"]),

    async submit() {
      const result = await this.create({ organizationId: this.organizationId, ...this.merchantProfile });
      if (!result) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Profil créé",
      });
      this.$emit("success");
    },
  },
};
</script>
